<template>
  <SelectComponent :value="value" @input="$ev => $emit('input', $ev)" v-bind="$attrs">
    <template #item="{ item, scope }">
      <Card :value="item" :disabled="isDisabled(item)" :scope="scope" />
    </template>
    <template #empty>
      <Card />
    </template>
    <template #noresults="{ filter }">
      <div class="text--center">{{ $t('couldnotfindonquery', { query: filter.search }) }}</div>
    </template>
  </SelectComponent>
</template>

<script>
import Card from '@/components/Flatfinder/Resources/Card'
import SelectComponent from '@/components/Select/Modal'

export default {
  props: {
    value: [Object, Array],
    disabledIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isDisabled(item) {
      return this.disabledIds.includes(item.id)
    },
  },
  components: {
    Card,
    SelectComponent,
  },
}
</script>
